import Vue from 'vue'
import Alert from '@/components/dialog/VipAlert' // 引入刚才写的弹框组件
let AlertConstructor = Vue.extend(Alert) // 返回一个“扩展实例构造器”

let VipAlert = (o) => {
  let alertDom = new AlertConstructor({
    el: document.createElement('div') // 将Alert组件挂载到新创建的div上
  })
  document.body.appendChild(alertDom.$el) // 把Alert组件的dom添加到body里

  alertDom.title = o.title || '信息'
  alertDom.a_close = o.close || null
  alertDom.a_confirm = o.confirm || null
  alertDom.a_cancel = o.cancel || null
}
export default VipAlert



// WEBPACK FOOTER //
// ./src/utils/VipAlert.js